import { Field, Form, Formik, useFormikContext } from "formik";
import { useRef } from "react";
import { Modal } from "react-bootstrap";
import { BsXLg } from "react-icons/bs";
import validationSchema from "../../../Validation/ValidationSchemas";

const SoftwareStrengths = ({
  openModal,
  closeModal,
  changeHandlerSoftwareStrength,
  fileName,
  handleSoftwareStrengthtitle,
  handleSoftwareStrengthdetails,
  name,
  content,
  softwarePostCall,
}) => {
  const formRef = useRef();
  const handleSubmitForm = () => {
    formRef.current.handleSubmit();
  };
  return (
    <div>
      <div>
        <Formik
          innerRef={formRef}
          initialValues={{
            selectedFileName: "",
            title: name,
            details: content,
          }}
          validationSchema={validationSchema.softwareStrengthsSchema}
          onSubmit={(values) => softwarePostCall(values)}
        >
          {(formik) => (
            <Form>
              {openModal && (
                <Modal id="mwidth" show={true}>
                  <Modal.Header>
                    <div className="d-flex justify-content-between w-100">
                      <h1 className="fs-20 semi-bold">Add Software Strength</h1>
                      <BsXLg
                        className="crossview cp"
                        onClick={closeModal}
                      ></BsXLg>
                    </div>
                  </Modal.Header>

                  <Modal.Body>
                    <label className="fs-18 semi-bold">ICON IMAGE</label>
                    <div>
                      <label
                        htmlFor="filePicker"
                        className="browseBTN"
                        style={{ padding: "12px 10px" }}
                      >
                        <u>Browse</u>
                      </label>
                      <span className="pl-3 fs-18 medium newgreyTXT">
                        {fileName ? fileName.slice(0, 15) : "No file chosen"}
                      </span>
                      <input
                        id="filePicker"
                        style={{ visibility: "hidden" }}
                        type={"file"}
                        onChange={(e) =>
                          changeHandlerSoftwareStrength(e, formRef)
                        }
                      ></input>
                      <p className=" imgsizeTXT text-dark">
                        Image Size : 80 px * 80 px
                      </p>
                      <div className="errorMsg fs-14 medium">
                        {formik.touched.selectedFileName &&
                          formik.errors.selectedFileName}
                      </div>
                    </div>

                    <div className="clear10"></div>
                    <p className="fs-18 semi-bold black">
                      TITLE{" "}
                      <span className="fs-16 regular newgreyTXT">
                        (Character Limit 20)
                      </span>
                    </p>
                    <div className="clear10"></div>
                    <Field
                      type="text"
                      name="title"
                      className={`form-control w-100 faqtextbox1 ${
                        formik.errors.title && "is-invalid"
                      }`}
                      placeholder="Setup your teams"
                    />
                    <div className="errorMsg fs-14 medium">
                      {formik.touched.title && formik.errors.title}
                    </div>

                    <div className="clear10"></div>
                    <p className="fs-18 semi-bold black">
                      DECRIPTION{" "}
                      <span className="fs-16 regular newgreyTXT">
                        (Character Limit 140)
                      </span>
                    </p>
                    <div className="clear10"></div>
                    <Field
                      as="textarea"
                      rows="3"
                      col="12"
                      name="details"
                      className={`form-control w-100 faqtextbox1 ${
                        formik.errors.details && "is-invalid"
                      }`}
                      placeholder="Enter details here"
                    />
                    <div className="errorMsg fs-14 medium">
                      {formik.touched.details && formik.errors.details}
                    </div>
                  </Modal.Body>

                  <Modal.Footer>
                    <div className="d-flex-align-cent mg-top-20">
                      <button
                        type="button"
                        className="cancelbtn mr-2"
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className={`${
                          formik.isValid ? "saveBtn1" : "saveBtn1 activv"
                        }`}
                        disabled={!formik.isValid}
                        onClick={() => handleSubmitForm()}
                      >
                        Save
                      </button>
                    </div>
                  </Modal.Footer>
                </Modal>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SoftwareStrengths;
